import React from 'react'
import '../styles/mainpage.css'
import cauzen from '../assest/CauZen.png'

const mainpage = () => {
  return (
    <div className='mainpage-container'>
        <div className='mainpage-wrapper'>
            <h1>Custom tech solutions—from idea to execution
for the <span> industries that shape the world</span>.</h1>
        <div className='mainpage-bottom'>
       
            <div className='mainpage-left'>
                <h1>Technology with <span>purpose </span><br/> Innovation with  <span>clarity</span></h1>
                 <button
            className="main-btn"
            onClick={() => {
              document.getElementById("about").scrollIntoView({ behavior: "smooth" });
            }}
          >
            Know More <span className="arrow"><i className="fas fa-arrow-right"></i></span>
          </button>
          <button
            className="main-btn2"
            onClick={() => {
              document.getElementById("solution").scrollIntoView({ behavior: "smooth" });
            }}
          >
            View Solution <span className="arrow"><i className="fas fa-arrow-right"></i></span>
          </button>
            </div>
                    <div className='mainpage-right'>
                        <img src={cauzen}/>
                    </div>
        </div>
        </div>
        
      
    </div>
  )
}

export default mainpage
